/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Atendant from './atendant';
import AtendantDetail from './atendant-detail';
import AtendantUpdate from './atendant-update';
import AtendantDeleteDialog from './atendant-delete-dialog';

const AtendantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Atendant />} />
    <Route path="new" element={<AtendantUpdate />} />
    <Route path=":id">
      <Route index element={<AtendantDetail />} />
      <Route path="edit" element={<AtendantUpdate />} />
      <Route path="delete" element={<AtendantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AtendantRoutes;
